import { useState } from 'react';

const isSameOrder = (ids, otherIds) =>
  ids.length === otherIds.length &&
  ids.every((id, index) => id === otherIds[index]);

export default function useOrderedIds(ids) {
  const [orderedIds, setOrderedIds] = useState(ids);
  const [serverIds, setServerIds] = useState(ids);

  if (!isSameOrder(serverIds, ids)) {
    setServerIds(ids);
    setOrderedIds(ids);
  }

  return [orderedIds, setOrderedIds];
}
